<template>
    <div>
        <v-layout row wrap style="margin-top: 64px">
            <v-flex xs12 sm12 md8 class="mb-2">
               <file-select v-model="file"></file-select>
            </v-flex>
            <v-flex xs12 sm12 md4 v-if="photo.startsWith('photo')">
                <img :src="laPhoto" alt="photo">
                    <v-btn  @click.native="deletePhoto" class="red--text darken-1">Supprimer la photo</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md4 v-else>
                <img :src="laPhoto" alt="photo">
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    import {ajax_img, ajax_post} from '../../public/global.js'
    import FileSelect from './FileSelect.vue'
    export default {
        components: {FileSelect},
        data() {
            return {
                photo: '',
                file: null
            }
        },
        methods: {
            imageChange(){
                let fd = new FormData()
                fd.append("token", this.$token())
                fd.append("fichier", this.file)
                fd.append("id", this.$route.params.id)
                fd.append("old", this.photo)
                ajax_img("/PHP/ajax/photo.php", fd).then((response)=>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        this.$root.$emit('myinfo', {title: "Serenity", msg: "Photo enregistrée !", color: ""})
                        this.fetchData()
                    }else{
                        this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            },
            deletePhoto(){
                ajax_post(`/PHP/ajax/deletePhoto.php`,`token=${this.$token()}&id=${this.$route.params.id}&photo=${this.photo}`).then((response) =>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        this.$root.$emit('myinfo', {title: "Serenity", msg: "Photo supprimée !", color: ""})
                        this.fetchData()
                    }else{
                        this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            },
            fetchData(){
                ajax_post(`/PHP/ajax/returnDef.php`,`token=${this.$token()}&id=${this.$route.params.id}`).then((response) =>{
                    let rep = JSON.parse(response)
                    if(!rep.error){
                        this.photo = rep.data.photo
                    }else{
                        this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
                    }
                })
            }
        },
        computed: {
            laPhoto (){
                return "/PHP/ajax/getPics.php?name=" + this.photo + "&$token=" + this.$token()
            }
        },
        created (){
         this.fetchData()   
        },
        watch: {
            file(){
                this.imageChange()
            }
        }
    }
</script>